import './_size-guide-pdp-modal-table.scss';
import component from './size-guide-pdp-modal-table';

export default component;
